import { useNavigate } from "react-router-dom";

// Store
import { useAppSelector, useAppDispatch } from "app/hooks";
import {
    getReportStatus,
    getIsNewAssessment,
    fetchPaceReportStatus,
    getIsFetchingReportStatus,
} from "store/slice/Pace/report";

// Others
import { urlPaths } from "enums/urlPaths";
import useAuth from "utils/hooks/useAuth";
import { unwrapResult } from "@reduxjs/toolkit";

// Types
import { createAssessment } from "store/slice/Pace";
import { toggleLoader } from "store/slice/UI";

const usePaceLandingLayout = () => {
    const isNewAssessment = !useAppSelector(getIsNewAssessment);
    const paceAssessmentStatus = useAppSelector(getReportStatus);
    const paceAssessmentRequestStatus = useAppSelector(getIsFetchingReportStatus);

    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const { loggedInUserData } = useAuth();

    const onGoingAssessment = paceAssessmentStatus?.user_assessments?.find(
        (assessment) => assessment.meta.status === "ACTIVE"
    );

    const handleStartPace = async () => {
        dispatch(toggleLoader(true));

        if (onGoingAssessment) {
            navigate(`${urlPaths.PaceAssessment}/${onGoingAssessment.user_assessment_id}`);
            dispatch(toggleLoader(false));
            return;
        }

        try {
            const result = unwrapResult(await dispatch(createAssessment(loggedInUserData.userId)));

            const userAssessmentId = result?.user_assessment_id;

            if (userAssessmentId) {
                await dispatch(fetchPaceReportStatus(loggedInUserData.userId));
                navigate(`${urlPaths.PaceAssessment}/${userAssessmentId}`);
            }
        } catch (err) {
            console.error(err);
        } finally {
            dispatch(toggleLoader(false));
        }
    };

    return {
        isNewAssessment,
        paceAssessmentStatus,
        hasOnGoingAssessment: Boolean(onGoingAssessment),
        paceAssessmentRequestStatus,
        handleStartPace,
    };
};

export default usePaceLandingLayout;
